import { Routes } from '@angular/router';
import { ClientDetailComponent } from './components/matwins-manager/client/client-detail/client-detail.component';
import { ClientListComponent } from './components/matwins-manager/client/client-list/client-list.component';
import { DockDetailComponent } from './components/matwins-tenant/dock/dock-detail/dock-detail.component';
import { DockListComponent } from './components/matwins-tenant/dock/dock-list/dock-list.component';
import { TruckerDetailComponent } from './components/matwins-tenant/trucker/trucker-detail/trucker-detail.component';
import { TruckerListComponent } from './components/matwins-tenant/trucker/trucker-list/trucker-list.component';
import { TruckerActivityDetailComponent } from './components/matwins-tenant/trucker-activity/activity-detail/trucker-activity-detail.component';
import { TruckerActivityListComponent } from './components/matwins-tenant/trucker-activity/activity-list/trucker-activity-list.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HomeComponent } from './components/home/home.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { TruckerFeatureComponent } from './components/trucker-feature/trucker-feature.component';
import { TenantAccountListComponent } from './components/matwins-tenant/account/account-list/account-list.component';
import { TenantAccountDetailComponent } from './components/matwins-tenant/account/account-detail/account-detail.component';
import { EmployeeListComponent } from './components/matwins-tenant/employee/employee-list/employee-list.component';
import { EmployeeDetailComponent } from './components/matwins-tenant/employee/employee-detail/employee-detail.component';
import { PermissionTenantComponent } from './components/matwins-tenant/permission-tenant/permission-tenant.component';
import { ManagerAccountListComponent } from './components/matwins-manager/account/account-list/account-list.component';
import { ManagerAccountDetailComponent } from './components/matwins-manager/account/account-detail/account-detail.component';
import { AuthGuard } from '@app/common-codes/guards/auth.guard';
import { VisitorContainmentGuard } from './guards/visitor-containment.guard';
import { AuthCallbackComponent } from './auth-callback.component';
import { QRCodeLayoutComponent } from './components/qrcode/qrcode-layout.component';
import { TruckerCheckinCheckoutComponent } from './components/qrcode/trucker-checkin/trucker-checkin-checkout.component';
import { QrcodeHomeComponent } from './components/qrcode/qrcode-home/qrcode-home.component';
import { QrcodeVisitorTypeComponent } from './components/qrcode/visitor-type/qrcode-visitor-type.component';
import { QrcodeVisitorCheckinComponent } from './components/qrcode/visitor-checkin/qrcode-visitor-checkin.component';
import { QrcodeVisitorCheckoutComponent } from './components/qrcode/visitor-checkout/qrcode-visitor-checkout.component';
import { UploadsComponent } from './components/qrcode/upload-document/uploads.component';
import { LanguageListComponent } from './components/matwins-manager/language/language-list.component';
import { VisitorFeatureComponent } from './components/visitor-feature/visitor-feature.component';
import { VisitListComponent } from './components/matwins-tenant/visit/visit-list/visit-list.component';
import { VisitDetailComponent } from './components/matwins-tenant/visit/visit-detail/visit-detail.component';
import { AccessCardListComponent } from './components/matwins-tenant/access-card/access-card-list/access-card-list.component';
import { AccessCardDetailComponent } from './components/matwins-tenant/access-card/access-card-detail/access-card-detail.component';
import { DeliveryListComponent } from './components/matwins-tenant/delivery/delivery-list/delivery-list.component';
import { DeliveryDetailComponent } from './components/matwins-tenant/delivery/delivery-detail/delivery-detail.component';
import { BuzzerConfigListComponent } from './components/matwins-tenant/buzzer-config/buzzer-config-list/buzzer-config-list.component';
import { BuzzerConfigDetailComponent } from './components/matwins-tenant/buzzer-config/buzzer-config-detail/buzzer-config-detail.component';
import { IpadLayoutComponent } from './components/ipad/ipad-layout.component';
import { IPadHomeComponent } from './components/ipad/ipad-home/ipad-home.component';
import { IPadVisitorTypeComponent } from './components/ipad/ipad-visitor-type/ipad-visitor-type.component';
import { VisitorCheckinComponent } from './components/ipad/checkin/visitor-checkin/visitor-checkin.component';
import { GroupCheckinComponent } from './components/ipad/checkin/group-checkin/group-checkin.component';
import { ContractorCheckinComponent } from './components/ipad/checkin/contractor-checkin/contractor-checkin.component';
import { EmployeeCheckinComponent } from './components/ipad/checkin/employee-checkin/employee-checkin.component';
import { DeliveryCheckinComponent } from './components/ipad/checkin/delivery-checkin/delivery-checkin.component';
import { IpadPosChoiceComponent } from './components/ipad/pos-choice/pos-choice.component';
import { IpadErrorComponent } from './components/ipad/error/ipad-error.component';
import { CheckoutComponent } from './components/ipad/checkout/checkout.component';
import { EmployeeQrCodeComponent } from './components/ipad/employee-qrcode/employee-qrcode.component';
import { DebugOnlyGuard } from '@app/common-codes/guards/debug-only.guard';
import { QrVisitWipComponent } from './components/qrcode/visits-wip/qr-visit-wip.component';
import { ScheduledTasksComponent } from './components/scheduled-tasks/scheduled-tasks.component';


// Définir une interface pour les routes avec paramètres optionnels
interface RouteConfig {
  LIST: string;
  ADD: string;
  EDIT: string;
  DETAIL: string;
}
// On en profite pour definir des contantes de routes 
// pour renforcer le typage des routes

// Définir les constantes de routes pour chaque entité

export const CLIENT_ROUTES: RouteConfig = {
  LIST: 'clients',
  ADD: 'client/add',
  EDIT: 'client/edit/:id',
  DETAIL: 'client/detail/:id'
} as const;

export const DOCK_ROUTES: RouteConfig = {
  LIST: 'docks',
  ADD: 'dock/add',
  EDIT: 'dock/edit/:id',
  DETAIL: 'dock/detail/:id'
} as const;

export const TRUCKER_ROUTES: RouteConfig = {
  LIST: 'trucks',
  ADD: 'trucker/add',
  EDIT: 'trucker/edit/:id',
  DETAIL: 'trucker/detail/:id'
} as const;

export const TENANT_ACCOUNT_ROUTES: RouteConfig = {
  LIST: 'tenantAccounts',
  ADD: 'tenantAccount/add',
  EDIT: 'tenantAccount/edit/:id',
  DETAIL: 'tenantAccount/detail/:id'
} as const;

export const MANAGER_ACCOUNT_ROUTES: RouteConfig = {
  LIST: 'managerAccounts',
  ADD: 'managerAccount/add',
  EDIT: 'managerAccount/edit/:id',
  DETAIL: 'managerAccount/detail/:id'
} as const;

export const EMPLOYEE_ROUTES: RouteConfig = {
  LIST: 'employees',
  ADD: 'employee/add',
  EDIT: 'employee/edit/:id',
  DETAIL: 'employee/detail/:id'
} as const;

export const TRUCKER_ACTIVITY_ROUTES: RouteConfig = {
  LIST: 'trucker-activities',
  ADD: 'trucker-activity/add',
  EDIT: 'trucker-activity/edit/:id',
  DETAIL: 'trucker-activity/detail/:id'
} as const;

export const VISIT_ROUTES: RouteConfig = {
  LIST: 'visits',
  ADD: 'visit/add',
  EDIT: 'visit/edit/:id',
  DETAIL: 'visit/detail/:id'
} as const;

export const ACCESS_CARD_ROUTES: RouteConfig = {
  LIST: 'access-cards',
  ADD: 'access-card/add',
  EDIT: 'access-card/edit/:id',
  DETAIL: 'access-card/detail/:id'
} as const;

export const DELIVERY_ROUTES: RouteConfig = {
  LIST: 'deliveries',
  ADD: 'delivery/add',
  EDIT: 'delivery/edit/:id',
  DETAIL: 'delivery/detail/:id'
} as const;

export const BUZZER_ROUTES: RouteConfig = {
  LIST: 'buzzers',
  ADD: 'buzzer/add',
  EDIT: 'buzzer/edit/:id',
  DETAIL: 'buzzer/detail/:id'
} as const;

export const AppRoutes = {
  Client: CLIENT_ROUTES,
  Dock: DOCK_ROUTES,
  Trucker: TRUCKER_ROUTES,
  TenantAccount: TENANT_ACCOUNT_ROUTES,
  ManagerAccount: MANAGER_ACCOUNT_ROUTES,
  Employee: EMPLOYEE_ROUTES,
  TruckerActivity: TRUCKER_ACTIVITY_ROUTES,
  AccessCard: ACCESS_CARD_ROUTES,
  Visit: VISIT_ROUTES,
  Delivery: DELIVERY_ROUTES,
  BuzzerConfig: BUZZER_ROUTES
} as const;



// Partagees par la route kiosque (ipad) et sa variante parametree (ipad/:tenant/:pos)
const IPAD_CHILDREN: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: IPadHomeComponent },
  { path: 'visitor-type', component: IPadVisitorTypeComponent },
  { path: 'checkin/visitor', component: VisitorCheckinComponent },
  { path: 'checkin/contractor', component: ContractorCheckinComponent },
  { path: 'checkin/employee', component: EmployeeCheckinComponent },
  { path: 'checkin/delivery', component: DeliveryCheckinComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'checkin/group', component: GroupCheckinComponent },
  { path: 'employee-qrcode', component: EmployeeQrCodeComponent },
  { path: 'error', component: IpadErrorComponent },
];

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard, VisitorContainmentGuard],  // Appliquer au niveau parent
    children: [
      { path: '', redirectTo: 'visitor-feature', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'visitor-feature', component: VisitorFeatureComponent },
      { path: 'trucker-feature', component: TruckerFeatureComponent },
      { path: 'permission/:roleType', component: PermissionTenantComponent },
      { path: 'override-translation', component: LanguageListComponent },
      { path: 'scheduled-tasks', component: ScheduledTasksComponent },
      { path: AppRoutes.Client.LIST, component: ClientListComponent },
      { path: AppRoutes.Client.ADD, component: ClientDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.Client.EDIT, component: ClientDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.Client.DETAIL, component: ClientDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.Dock.LIST, component: DockListComponent },
      { path: AppRoutes.Dock.ADD, component: DockDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.Dock.EDIT, component: DockDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.Dock.DETAIL, component: DockDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.Trucker.LIST, component: TruckerListComponent },
      { path: AppRoutes.Trucker.ADD, component: TruckerDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.Trucker.EDIT, component: TruckerDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.Trucker.DETAIL, component: TruckerDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.TenantAccount.LIST, component: TenantAccountListComponent },
      { path: AppRoutes.TenantAccount.ADD, component: TenantAccountDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.TenantAccount.EDIT, component: TenantAccountDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.TenantAccount.DETAIL, component: TenantAccountDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.ManagerAccount.LIST, component: ManagerAccountListComponent },
      { path: AppRoutes.ManagerAccount.ADD, component: ManagerAccountDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.ManagerAccount.EDIT, component: ManagerAccountDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.ManagerAccount.DETAIL, component: ManagerAccountDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.Employee.LIST, component: EmployeeListComponent },
      { path: AppRoutes.Employee.ADD, component: EmployeeDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.Employee.EDIT, component: EmployeeDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.Employee.DETAIL, component: EmployeeDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.TruckerActivity.LIST, component: TruckerActivityListComponent },
      { path: AppRoutes.TruckerActivity.ADD, component: TruckerActivityDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.TruckerActivity.EDIT, component: TruckerActivityDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.TruckerActivity.DETAIL, component: TruckerActivityDetailComponent, data: { mode: 'view' } },


      { path: AppRoutes.Visit.LIST, component: VisitListComponent },
      { path: AppRoutes.Visit.ADD, component: VisitDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.Visit.EDIT, component: VisitDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.Visit.DETAIL, component: VisitDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.AccessCard.LIST, component: AccessCardListComponent },
      { path: AppRoutes.AccessCard.ADD, component: AccessCardDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.AccessCard.EDIT, component: AccessCardDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.AccessCard.DETAIL, component: AccessCardDetailComponent, data: { mode: 'view' } },

      { path: AppRoutes.Delivery.LIST, component: DeliveryListComponent },
      { path: AppRoutes.Delivery.ADD, component: DeliveryDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.Delivery.EDIT, component: DeliveryDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.Delivery.DETAIL, component: DeliveryDetailComponent, data: { mode: 'view' } },
      { path: AppRoutes.BuzzerConfig.LIST, component: BuzzerConfigListComponent },
      { path: AppRoutes.BuzzerConfig.ADD, component: BuzzerConfigDetailComponent, data: { mode: 'add' } },
      { path: AppRoutes.BuzzerConfig.EDIT, component: BuzzerConfigDetailComponent, data: { mode: 'edit' } },
      { path: AppRoutes.BuzzerConfig.DETAIL, component: BuzzerConfigDetailComponent, data: { mode: 'view' } },

    ]
  },
  { path: 'unauthorized', component: UnauthorizedComponent, canActivate: [VisitorContainmentGuard] },
  {
    path: 'qrcode/:tenant/:pos', component: QRCodeLayoutComponent,
    canActivate: [VisitorContainmentGuard],
    children: [
      { path: 'home', component: QrcodeHomeComponent },
      { path: 'visitor-type', component: QrcodeVisitorTypeComponent },
      { path: 'checkout-type', component: QrcodeVisitorTypeComponent, data: { mode: 'checkout' } },
      { path: 'checkin/:type', component: QrcodeVisitorCheckinComponent },
      { path: 'checkout', component: QrcodeVisitorCheckoutComponent },
      { path: 'trucker-checkin', component: TruckerCheckinCheckoutComponent },
      { path: 'trucker-edit/:id', component: TruckerCheckinCheckoutComponent },
      { path: 'trucker-checkout', component: TruckerCheckinCheckoutComponent },
      { path: 'uploads/:activityId', component: UploadsComponent },
      { path: 'visits-wip', canMatch: [DebugOnlyGuard], component: QrVisitWipComponent }
    ]
  },
  {
    path: 'ipad', component: IpadLayoutComponent,
    children: IPAD_CHILDREN
  },
  // Variante parametree : l'URL designe le client (liens du Test-Hub). Le kiosque garde la route nue.
  {
    path: 'ipad/:tenant/:pos', component: IpadLayoutComponent,
    children: IPAD_CHILDREN
  },
  {
    path: 'ipad-pos-choice', component: IpadPosChoiceComponent
  },
  // Nouvelle route de callback - doit être accessible sans authentification
  { path: 'auth-callback', component: AuthCallbackComponent },
  // URL inconnue : le compte Visitor est renvoyé dans /ipad, les autres voient la page d'erreur.
  { path: '**', component: UnauthorizedComponent, canActivate: [VisitorContainmentGuard] }

];



// Utilisation dans les components
//this.router.navigate([DB_ROUTES.DETAIL, id]);
// ou
//this.router.navigate([APP_ROUTES.DATABASE.DETAIL, id]);


